import {adminApi} from '../services'

// The backend serves the catalog at most 100 services a page (its cap), so it
// is read page by page until the last one: a single request would silently cut
// the list off once the catalog outgrows a page.
export const SERVICE_CATALOG_PAGE_SIZE = 100

export const loadServiceCatalog = async () => {
    const services = []
    for (let page = 1; ; page++) {
        const {data: body} = await adminApi.listServiceCatalog({limit: SERVICE_CATALOG_PAGE_SIZE, page})
        services.push(...(body?.data || []))
        const pages = body?.meta?.pages || 1
        if (page >= pages || !body?.data?.length) return services
    }
}
